import { PartType } from '../constants/part-type.js';
/**
 * Stockable part types occupy physical space and therefore need a default location and reorder
 * levels. Non-stockable types (Non-Inventory, Service, Overhead) must not be asked for either.
 */
const STOCKABLE_PART_TYPES = new Set([
    PartType.INVENTORY,
    PartType.INTERNAL_USE,
    PartType.CAPITAL_EQUIPMENT,
]);
export function isStockablePartType(typeId) {
    const id = typeof typeId === 'string' ? Number(typeId) : typeId;
    return Number.isFinite(id) && STOCKABLE_PART_TYPES.has(id);
}
//# sourceMappingURL=is-stockable-part-type.js.map